// export const BaseURL = "https://visionapi.aptech-education.com.pk/api/";
export const BaseURL = "https://testing.ischool.pk/api/";
export const PublicURLImages =
  "https://testing.ischool.pk/assets/images/";
// export const BaseURL = "http://192.168.1.119:8000/api/";
// export const PublicURLImages = "http://192.168.1.119:8000/assets/images/";
//
